export interface InnerPageProps {
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
  onClose: () => void;
}

export const innerPageSpacing = 3;
